import axios from "axios";
import axiosRetry from "axios-retry";

// intercept
axiosRetry(axios, {
  retries: 3,
  retryCondition: (error) => {
    return error.response.status === 429;
  },
});
const API = axios.create({
  baseURL: "https://eyenovel-backend.vercel.app",
  withCredentials: true,
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.authorization = `Bearer ${
      JSON.parse(localStorage.getItem("profile")).token
    }`;
  }
  return req;
});

// Chapters
export const fetchChapters = (id) => API.get(`/novels/chapters/${id}`);
export const fetchChapter = (id) => API.get(`/novels/chapter/${id}`);
// CRUD
export const createNovelChaps = (newNovel) =>
  API.post("/novels/chapters", newNovel);
export const updateNovelChaps = (id, updateChaps) =>
  API.patch(`/novels/chapters/${id}`, updateChaps);
export const deleteNovelChaps = (id) => API.delete(`/novels/chapters/${id}`);
export const deleteNovelChapsAll = (id) =>
  API.delete(`/novels/chapters/all/${id}`);

// Novels
export const fetchNovelsPagination = (searchQuery, paginationSource) =>
  API.get(
    `/novels/?page=${searchQuery.page}&limit=${searchQuery.limit}&search=${searchQuery.search}&genre=${searchQuery.genre}`,
    {
      cancelToken: paginationSource.token, // <-- 2nd step
    }
  );
export const fetchRecentNovel = (recentSource) =>
  API.get(`/novels/recentNovel`, {
    cancelToken: recentSource.token, // <-- 1nd step
  });
export const fetchComingSoon = (soonSource) =>
  API.get(`/novels/comingSoon`, {
    cancelToken: soonSource.token, // <-- 2nd step
  });
export const fetchSpecialForYou = (specialSource) =>
  API.get(`/novels/specialforyou`, {
    cancelToken: specialSource.token, // <-- 2nd step
  });
export const fetchLatestUserNovels = (latestNovelComments) =>
  API.post(`/novels/latestNovelComments`, latestNovelComments);
// UserNovels
export const fetchUserNovelsCRUD = (id, userDetailsSource) =>
  API.get(`/novels/${id}`, {
    cancelToken: userDetailsSource.token, // <-- 2nd step
  });
// NovelPage
export const fetchNovel = (id, novelSource) =>
  API.get(`/novels/currentNovel/${id}`, {
    cancelToken: novelSource.token, // <-- 2nd step
  });
export const UpdateCurrentNovel = (id, updateCurrentNovel) =>
  API.patch(`/novels/currentNovel/${id}`, updateCurrentNovel);
export const fetchSuggestionsNovels = (Suggestedtags, suggestSource) =>
  API.post(`/novels/currentNovel/suggestions`, Suggestedtags, {
    cancelToken: suggestSource.token, // <-- 2nd step
  });
// Favorites

export const fetchFavoriteNovel = (favoriteNovels, favoriteSource) =>
  API.post(`/novels/favorites`, favoriteNovels);
export const createNovel = (newNovel) => API.post("/novels", newNovel);
export const updateNovel = (id, novel) => API.patch(`/novels/${id}`, novel);
export const deleteNovel = (id) => API.delete(`/novels/${id}`);

export const updateUser = (id, novel) => API.patch(`/users/${id}`, novel);
export const getUser = (id, userSource) =>
  API.get(`/users/${id}`, {
    cancelToken: userSource.token, // <-- 2nd step
  });
export const getLocalUser = (id) => API.get(`/users/${id}`);
export const fetchuserComments = (listOfIds) =>
  API.post(`/users/userComments`, listOfIds);

export const googleAuth = () => API.get("/users/auth/login/success");
export const googleAuthLogout = () => API.get("/users/auth/logout");
export const signIn = (formData) => API.post("/users/signin", formData);
export const signUp = (formData) => API.post("/users/signup", formData);

export const fetchLatestComments = () => API.get(`/comments/latestComments`);
export const fetchUpdatedLikes = (id, updatedObj) =>
  API.patch(`/comments/${id}`, updatedObj);
export const deleteComments = (id) => API.delete(`/comments/all/${id}`);
export const fetchComment = (id) => API.get(`/comments/${id}`);
export const createComment = (newComment) => API.post("/comments", newComment);

export const createReport = (report) => API.post("/reports", report);
